import { environment } from '@env';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, RouterStateSnapshot, UrlSegment, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '@shared/modules/account/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {
  constructor(
    private userService: UserService,
    private router: Router
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(this.userService.isLoggedInSync())
        return true;

      this.router.navigate(['/account/login'], { queryParams: { returnUrl: state.url }});
      return false;
  }

  canLoad(route: Route, segments: UrlSegment[]): boolean | Observable<boolean> | Promise<boolean> {    
    const result = this.userService.isLoggedInSync();
    const url = `${environment.baseUrl}/${segments.join('/')}`;
    
    !result && this.router.navigate(['/account/login'], { queryParams: { returnUrl: url }});
    
    return result;
  }
}
